export default __webpack_public_path__ + "static/media/NIAS0400.34I-29079_-16915_0.698f1f37.jpg";